import { motion } from "framer-motion";
import CTAButton from "../CTAButton";
import { ASSETS } from "../../data/content";

export default function Act1Hero() {
  return (
    <section
      data-testid="act-hero"
      className="relative min-h-[100svh] w-full overflow-hidden flex items-end"
    >
      <motion.div
        initial={{ scale: 1.12, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img
          src={ASSETS.about}
          alt="Jordi Betoret — Elite Coaching"
          className="w-full h-full object-cover object-[50%_18%]"
        />
      </motion.div>

      {/* Cinematic gradients para legibilidad */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#030303] via-[#030303]/55 to-[#030303]/25" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#030303]/80 via-[#030303]/15 to-transparent" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 pb-20 md:pb-28">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="block font-display text-[10px] md:text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-6 md:mb-8"
        >
          Elite Coaching · JordyBT_Fitness
        </motion.span>

        <h1 className="font-serif font-medium text-white tracking-tight leading-[1.0] text-[2.4rem] sm:text-5xl md:text-6xl lg:text-[4.6vw] max-w-[20ch]">
          <motion.span
            initial={{ opacity: 0, y: 36 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.75, duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="block"
          >
            No solo transformamos tu físico.
          </motion.span>
          <motion.span
            initial={{ opacity: 0, y: 36 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="block italic gold-text"
          >
            Transformamos la forma en la que te ves.
          </motion.span>
        </h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.45, duration: 1 }}
          className="mt-7 md:mt-9 font-display font-light text-white/80 text-base sm:text-lg md:text-2xl leading-snug max-w-[34ch]"
        >
          El cuerpo es la consecuencia de convertirte en la persona que siempre has querido ser.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.75, duration: 1 }}
          className="mt-9 md:mt-11"
        >
          <CTAButton testid="hero-cta" />
        </motion.div>
      </div>

      {/* Scroll cue (solo escritorio para no estorbar en móvil) */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.2, duration: 1 }}
        className="hidden md:flex absolute bottom-8 right-12 z-10 flex-col items-center gap-3"
      >
        <span className="font-display text-[9px] tracking-[0.3em] uppercase text-white/40 [writing-mode:vertical-rl]">
          Desliza
        </span>
        <motion.div
          animate={{ height: [10, 28, 10], opacity: [0.3, 1, 0.3] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-px bg-[#D4AF37]"
        />
      </motion.div>
    </section>
  );
}
